var exports = {
  "t": "highlightedText__8DnsfV",
};

module.exports = exports;
